import React from 'react';
import PublicBookingSection from '../../components/PublicBookingSection';
import { IITH, SERIF, SANS } from './iithBrand';

/** Public OPD booking block — placed high on the landing page. */
export default function LandingBookingSection({
  slug, primary, bookPreset, doctorProfiles,
}) {
  return (
    <section id="contact" className="py-16 sm:py-20 border-t border-white/10" style={{ background: IITH.navy }}>
      <div className="max-w-3xl mx-auto px-5 sm:px-6">
        <div className="text-center">
          <p className="text-[11px] uppercase tracking-[0.22em]" style={{ color: IITH.gold }}>Appointments</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mt-2" style={{ fontFamily: SERIF }}>
            Book your <span style={{ color: primary }}>OPD visit</span>
          </h2>
          <p className="mt-3 max-w-xl mx-auto text-sm leading-relaxed" style={{ color: IITH.mute, fontFamily: SANS }}>
            Choose <strong style={{ color: '#e2e8f0' }}>Consulting</strong> to reserve a GP slot, or{' '}
            <strong style={{ color: '#e2e8f0' }}>Referral</strong> for specialist letters via the patient portal.
            Taken times show as <em>Taken</em> and cannot be selected.
          </p>
        </div>
        <div className="mt-8" id="book-section">
          <PublicBookingSection
            key={bookPreset?.key || 'default'}
            slug={slug}
            primary={primary}
            preset={bookPreset}
            doctorProfiles={doctorProfiles}
          />
        </div>
      </div>
    </section>
  );
}
